// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLogoutOutlinedSvg from "@fishx/icons-svg/es/asn/PLogoutOutlined";
import FishxIcon from '../components/FishxIcon';

var PLogoutOutlined = function PLogoutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLogoutOutlinedSvg
  }));
};

PLogoutOutlined.displayName = 'PLogoutOutlined';
export default React.forwardRef(PLogoutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLogoutOutlined.js
// module id = 3502
// module chunks = 0